__turbopack_context__.v({
  "dateContainer": "CalendarDate-module-scss-module__Honw9G__dateContainer",
  "disabled": "CalendarDate-module-scss-module__Honw9G__disabled",
  "highlighted": "CalendarDate-module-scss-module__Honw9G__highlighted",
  "outsideOfMonth": "CalendarDate-module-scss-module__Honw9G__outsideOfMonth",
  "selected": "CalendarDate-module-scss-module__Honw9G__selected",
  "today": "CalendarDate-module-scss-module__Honw9G__today",
  "unavailable": "CalendarDate-module-scss-module__Honw9G__unavailable",
});
